<template>
  <div class="container is-fluid">
    <template v-if="currentUser && profile">
      <navigation></navigation>
      <router-view></router-view>
      <hr />
      <amplify-sign-out></amplify-sign-out>
    </template>
    <amplify-authenticator v-else style="display: flex; justifyContent: center; padding-top: 10%;"></amplify-authenticator>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Navigation from './components/shared/nav'
export default {
  components: {
    Navigation
  },
  data () {
    return {
      loading: 0
    }
  },
  computed: mapState([ 'profile' ])
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
$primary: #408242;
$primary-invert: findColorInvert($primary);

$danger: #aa2727;
$danger-invert: findColorInvert(danger);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;


// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

@media screen and (min-width: 1024px) {
  .container.is-fluid {
    margin: 0 !important;
  }
}
</style>
